/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Review_HintInputs */

const en_us2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything is filled from last time. Change what changed.`)
};

const pt_br2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo vem da última vez. Mude o que mudou.`)
};

const es_419_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo viene de la última vez. Cambia lo que haya cambiado.`)
};

const pt_pt2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está tudo preenchido da última vez. Muda o que mudou.`)
};

const fr_fr2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est prérempli depuis la dernière fois. Modifie ce qui a changé.`)
};

const de_de2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles ist vom letzten Mal ausgefüllt. Ändere, was sich geändert hat.`)
};

const it_it2_intake_review_hint = /** @type {(inputs: Intake_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È tutto compilato dall'ultima volta. Cambia ciò che è cambiato.`)
};

/**
* | output |
* | --- |
* | "Everything is filled from last time. Change what changed." |
*
* @param {Intake_Review_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_review_hint = /** @type {((inputs?: Intake_Review_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Review_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_review_hint(inputs)
	if (locale === "es-419") return es_419_intake_review_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_review_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_review_hint(inputs)
	if (locale === "de-DE") return de_de2_intake_review_hint(inputs)
	if (locale === "it-IT") return it_it2_intake_review_hint(inputs)
	return en_us2_intake_review_hint(inputs)
});
export { intake_review_hint as "intake.review_hint" }